import { render } from 'lit-html';

import product from '../components/product/product';
import { ProductProps } from '../types/productProps';

import { widgetSelector } from './constants';

const renderProduct = (props: ProductProps): void => {
    const widget = document.querySelector(widgetSelector(props._.id)) as HTMLElement;
    render(product(props), widget);
};

export default renderProduct;
